import { Heading } from "@/shared-web.ui/ui.heading";
import { Text } from "@/shared-web.ui/ui.text";
import { cn } from "@/shared-web.ui/util.cn";

interface RootProps extends React.HTMLAttributes<HTMLDivElement> {}
const Root = (props: RootProps) => {
  const { className, children, ...rest } = props;
  return (
    <div
      className={cn(
        "grid grid-cols-1 gap-4",
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
};

interface TitleProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "children"> {
  children: string;
}
const Title = (props: TitleProps) => {
  const { className, children, ...rest } = props;
  return (
    <div
      className={cn(
        `row-start-1`,
        className,
      )}
      {...rest}
    >
      <Heading
        weight="medium"
        as="h3"
        size="4"
      >
        {children}
      </Heading>
    </div>
  );
};

interface BodyProps extends React.HTMLAttributes<HTMLDivElement> {
  disablePadding?: boolean;
}
const Body = (props: BodyProps) => {
  const { className, children, disablePadding, ...rest } = props;
  return (
    <div
      className={cn(
        `row-start-2`,
        disablePadding ? "" : "p-1",
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
};

interface RemarksProps extends React.HTMLAttributes<HTMLDivElement> {
  children: string;
}
const Remarks = (props: RemarksProps) => {
  const { className, children, ...rest } = props;
  return (
    <div
      className={cn(
        `row-start-3 -mt-3`,
        className,
      )}
      {...rest}
    >
      <Text size="1" color="gray">
        {children}
      </Text>
    </div>
  );
};

export {
  Body,
  Remarks,
  Root,
  Title,
};
